import type { TFunction } from "i18next";

export function defaultTableName(t: TFunction, index: number): string {
  return t("seating.defaults.tableName", { n: index });
}

export function defaultVipTableName(t: TFunction): string {
  return t("seating.defaults.vipTable");
}

export function defaultPlanName(t: TFunction): string {
  return t("seating.defaults.planName");
}

export function defaultNewPlanName(t: TFunction, index: number): string {
  return t("seating.defaults.newPlanName", { n: index });
}
